import { DutyRosterPeriodDto } from "@/@client/Theasoft_ApiServer_DutyRosters"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { SelectStartsWithFilter } from "@components/select/select-word-start-filter"
import { SelectProps, Select, ActionIcon } from "@mantine/core"
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

interface ReleasePeriodSelectProps
  extends Omit<SelectProps, "data" | "onChange"> {
  releasePeriods: DutyRosterPeriodDto[]
  onChange: (value: string | null) => void
}

export function ReleasePeriodSelect({
  releasePeriods,
  onChange,
  ...selectProps
}: ReleasePeriodSelectProps) {
  const { t } = useTranslation("app_server")

  const releasePeriodsData = releasePeriods.map((r) => ({
    value: r.startDate,
    label: `${dayjs(r.startDate).week()}. ${t("CW_CalendarWeek")} - ${getFormattedDate(r.startDate)}`,
  }))

  const valueIndex = releasePeriodsData.findIndex(
    (r) => r.value === selectProps.value
  )

  const hasNext = valueIndex < releasePeriodsData.length - 1
  const hasPrevious = valueIndex > 0

  const handleClickNext = () => {
    if (hasNext) {
      const nextValue = releasePeriodsData[valueIndex + 1].value
      onChange(nextValue)
    }
  }

  const handleClickPrevious = () => {
    if (hasPrevious) {
      const previousValue = releasePeriodsData[valueIndex - 1].value
      onChange(previousValue)
    }
  }

  const actionIconProps = { variant: "transparent" }

  return (
    <Select
      leftSection={
        <ActionIcon
          disabled={!hasPrevious}
          onClick={handleClickPrevious}
          {...actionIconProps}
        >
          <IconArrowLeft />
        </ActionIcon>
      }
      rightSectionPointerEvents="auto"
      rightSection={
        <ActionIcon
          disabled={!hasNext}
          onClick={handleClickNext}
          {...actionIconProps}
        >
          <IconArrowRight />
        </ActionIcon>
      }
      data={releasePeriodsData}
      filter={SelectStartsWithFilter}
      searchable
      label={t("Week")}
      onChange={onChange}
      {...selectProps}
    />
  )
}
